import React, { useContext } from 'react';
import {
  Box,
  ButtonBase,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  useTheme,
} from '@material-ui/core';
import { CreateMeetingContext } from '../../../services/create-meeting/create-meeting.context';

export const VirtualLink = () => {
  const { states } = useContext(CreateMeetingContext);

  const theme = useTheme();

  const urlStyle = {
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    },
  };

  const { id, setUrlChecked, urlChecked, urlRef, url, setUrl } = states;

  const toggleUrl = (e) => {
    setUrlChecked(e.target.checked);
  };

  return (
    <Box my={2}>
      <Grid container>
        <Grid item sm={3}>
          <ButtonBase>
            <FormControlLabel
              control={<Checkbox onChange={toggleUrl} checked={urlChecked} />}
              label={<Typography style={urlStyle}>Virtual meeting</Typography>}
            />
          </ButtonBase>
        </Grid>
        <Grid item sm={9}>
          {urlChecked ? (
            <TextField
              type='url'
              size='small'
              label='Virtual meeting'
              variant='outlined'
              name='virtualLink'
              placeholder='www.mizbans.com'
              inputRef={urlRef}
              // error={urlError}
              // helperText={
              //   <Typography variant='caption' color='error'>
              //     {url.helperText}
              //   </Typography>
              // }
              value={url.value}
              // defaultValue={url.value}
              onChange={(e) => {
                setUrl({
                  value: e.target.value,
                  error: false,
                  helperText: '',
                });
                !id && localStorage.setItem('url', e.target.value);
              }}
              fullWidth
            />
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};
